<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Dados de terceiros</b>
      </div>
      <div class="row g-3">
        <div class="col-md-12">
          <!--Nome (facultativo); -->
          <label for="nomeTerceiro" class="form-label">Nome</label>
          <InputText
            id="nomeTerceiro"
            v-model="objDTO.Sinistro.TerceiroContacto.Nome"
            class="form-control"
          />
        </div>
        <div class="col-md-6">
          <!--Telefone cel. (facultativo); -->
          <label for="telefoneTerceiro" class="form-label">Telefone</label>
          <imask-input
            id="telefoneTerceiro"
            v-model="objDTO.Sinistro.TerceiroContacto.Telemovel"
            class="form-control"
            :mask="phoneMask"
            :unmask="true"
          />
        </div>
        <div class="col-md-6">
          <!--E-mail (facultativo). -->
          <label for="emailTerceiro" class="form-label">Email</label>
          <InputText
            id="emailTerceiro"
            v-model="objDTO.Sinistro.TerceiroContacto.Email"
            class="form-control"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { IMaskComponent } from 'vue-imask';
import { iMaskConfig } from '../../../utils/constants';

export default {
  components: {
    'imask-input' : IMaskComponent,
  },
  data() {
    return {
      phoneMask : iMaskConfig.telemovel
    };
  },
  computed: {
    ...mapGetters({ objDTO: 'getObjDTO' }),
  },
};
</script>

<style></style>
